import React, { useEffect, useRef, useState } from 'react';
import alert from '@/assets/icon/alert.gif';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '@/components/units/button/Button';
import Icon from '@/components/units/Icon';
import { navigateToURL } from '@/utility/navigate';
import { VKYC_STATUS } from '@/constants';

const VKYCPendingBanner = () => {
  const [isClosed, setIsClosed] = useState(true);

  const isVKYCButtonVisible = useSelector(
    (state) => state?.featureflag?.dashboard?.vkyc?.vkycButton?.isVisible
  );

  const vkycStatus = useSelector((state) => state?.user?.user?.vkycStatus);

  const initialized = useRef(false);
  const isRejected = vkycStatus === VKYC_STATUS.REJECTED;

  // TODO : API implementation
  const handleVkycProcess = () => {
    console.log('VKYC Process');
  };

  useEffect(() => {
    if (!vkycStatus) return;

    if (!initialized.current) {
      initialized.current = true;
      setIsClosed(vkycStatus === VKYC_STATUS.COMPLETED);
    }
  }, [vkycStatus]);

  return isClosed ? null : (
    <div className="tw-max-w-screen-lg tw-w-full tw-px-7 tw-py-5 sm:tw-rounded-2xl tw-flex tw-items-center tw-justify-between tw-shadow-vkycTableGradiant tw-bg-vkycbackground ">
      <div className="tw-flex tw-items-center tw-gap-5">
        <div className="tw-h-11 tw-w-12 tw-overflow-hidden">
          <img src={alert} alt="show alert" className="tw-scale-[2]" />
        </div>
        <div>
          <h2 className="tw-text-xl tw-text-[#45848F]">Account Alert</h2>
          {isRejected ? (
            <p className="tw-text-base tw-text-[#F0566E]">
              Your Video KYC has been rejected. Please check email for further details.
            </p>
          ) : (
            <p className="tw-text-base">
              Your savings account is currently restricted.{' '}
              <button
                className="tw-outline-none tw-border-none tw-underline tw-text-[#45848F]"
                onClick={() => navigateToURL('/digital-bank/dashboard/account-benefits')}
              >
                Know more
              </button>
            </p>
          )}
        </div>
      </div>
      <div className="tw-flex tw-items-center tw-gap-5">
        {isVKYCButtonVisible && (
          <button
            type="button"
            className="tw-py-4 tw-w-52 tw-text-base tw-rounded-[42px] tw-flex tw-items-center tw-justify-center tw-gap-3 tw-bg-[#001316] tw-text-white tw-cursor-pointer"
            onClick={handleVkycProcess}
          >
            {isRejected ? 'Restart your video KYC' : 'Complete VKYC'}
          </button>
        )}
        <Icon
          iconName="close"
          wrapperStyle="tw-w-3.5 tw-cursor-pointer tw-text-primaryDark"
          onClick={() => setIsClosed(!isClosed)}
        />
      </div>
    </div>
  );
};

export default VKYCPendingBanner;
